import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var RESET_CURRENT_IMAGE = 'RESET_CURRENT_IMAGE';
export var SET_CURRENT_IMAGE = 'SET_CURRENT_IMAGE';
export var SET_PRODUCT_NAV = 'SET_PRODUCT_NAV';
export var SET_PRODUCT = 'SET_PRODUCT';
export var SET_PRODUCT_CAROUSELS = 'SET_PRODUCT_CAROUSELS';
export var SET_PRODUCT_IMAGES = 'SET_PRODUCT_IMAGES';
export var RESET_PRODUCT = 'RESET_PRODUCT';